'use strict';

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var cid = require('multiformats/cid');

var encoder = require('./encoder.js');

var iteratorChannel = require('./iterator-channel.js');

var decoder = require('./decoder.js');

var CarWriter = /*#__PURE__*/function () {
  function CarWriter(roots, encoder) {
    _classCallCheck(this, CarWriter);

    this._encoder = encoder;
    this._mutex = encoder.setRoots(roots);
    this._ended = false;
  }

  _createClass(CarWriter, [{
    key: "put",
    value: function () {
      var _put = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(block) {
        var _this = this;

        var cid$1;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!(block.bytes instanceof Uint8Array) || !block.cid)) {
                  _context.next = 2;
                  break;
                }

                throw new TypeError('Can only write {cid, bytes} objects');

              case 2:
                if (!this._ended) {
                  _context.next = 4;
                  break;
                }

                throw new Error('Already closed');

              case 4:
                cid$1 = cid.CID.asCID(block.cid);

                if (cid$1) {
                  _context.next = 7;
                  break;
                }

                throw new TypeError('Can only write {cid, bytes} objects');

              case 7:
                this._mutex = this._mutex.then(function () {
                  return _this._encoder.writeBlock({
                    cid: cid$1,
                    bytes: block.bytes
                  });
                });
                return _context.abrupt("return", this._mutex);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function put(_x) {
        return _put.apply(this, arguments);
      }

      return put;
    }()
  }, {
    key: "close",
    value: function () {
      var _close = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this._ended) {
                  _context2.next = 2;
                  break;
                }

                throw new Error('Already closed');

              case 2:
                _context2.next = 4;
                return this._mutex;

              case 4:
                this._ended = true;
                return _context2.abrupt("return", this._encoder.close());

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function close() {
        return _close.apply(this, arguments);
      }

      return close;
    }()
  }], [{
    key: "create",
    value: function create(roots) {
      roots = toRoots(roots);

      var _encodeWriter = encodeWriter(),
          encoder = _encodeWriter.encoder,
          iterator = _encodeWriter.iterator;

      var writer = new CarWriter(roots, encoder);
      var out = new CarWriterOut(iterator);
      return {
        writer: writer,
        out: out
      };
    }
  }, {
    key: "createAppender",
    value: function createAppender() {
      var _encodeWriter2 = encodeWriter(),
          encoder = _encodeWriter2.encoder,
          iterator = _encodeWriter2.iterator;

      encoder.setRoots = function () {
        return Promise.resolve();
      };

      var writer = new CarWriter([], encoder);
      var out = new CarWriterOut(iterator);
      return {
        writer: writer,
        out: out
      };
    }
  }, {
    key: "updateRootsInBytes",
    value: function () {
      var _updateRootsInBytes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(bytes, roots) {
        var reader, newHeader;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                reader = decoder.bytesReader(bytes);
                _context3.next = 3;
                return decoder.readHeader(reader);

              case 3:
                newHeader = encoder.createHeader(roots);

                if (!(reader.pos !== newHeader.length)) {
                  _context3.next = 6;
                  break;
                }

                throw new Error("updateRoots() can only overwrite a header of the same length (old header is ".concat(reader.pos, " bytes, new header is ").concat(newHeader.length, " bytes)"));

              case 6:
                bytes.set(newHeader, 0);
                return _context3.abrupt("return", bytes);

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function updateRootsInBytes(_x2, _x3) {
        return _updateRootsInBytes.apply(this, arguments);
      }

      return updateRootsInBytes;
    }()
  }]);

  return CarWriter;
}();

var CarWriterOut = /*#__PURE__*/function (_Symbol$asyncIterator) {
  function CarWriterOut(iterator) {
    _classCallCheck(this, CarWriterOut);

    this._iterator = iterator;
  }

  _createClass(CarWriterOut, [{
    key: _Symbol$asyncIterator,
    value: function value() {
      if (this._iterating) {
        throw new Error('Multiple iterator not supported');
      }

      this._iterating = true;
      return this._iterator;
    }
  }]);

  return CarWriterOut;
}(Symbol.asyncIterator);

function encodeWriter() {
  var iw = iteratorChannel.create();
  var writer = iw.writer,
      iterator = iw.iterator;
  var encoder$1 = encoder.createEncoder(writer);
  return {
    encoder: encoder$1,
    iterator: iterator
  };
}

function toRoots(roots) {
  if (roots === undefined) {
    return [];
  }

  if (!Array.isArray(roots)) {
    var cid$1 = cid.CID.asCID(roots);

    if (!cid$1) {
      throw new TypeError('roots must be a single CID or an array of CIDs');
    }

    return [cid$1];
  }

  var _roots = [];

  var _iterator = _createForOfIteratorHelper(roots),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var root = _step.value;

      var _root = cid.CID.asCID(root);

      if (!_root) {
        throw new TypeError('roots must be a single CID or an array of CIDs');
      }

      _roots.push(_root);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return _roots;
}

var __browser = true;
exports.CarWriter = CarWriter;
exports.CarWriterOut = CarWriterOut;
exports.__browser = __browser;